import { createSelector } from 'reselect';
import { SidebarStatePart } from 'src/setup/types';

import { separateVehiclesByType } from '../vehicles/utils';
import { BaseSidebarData, DRIVER_SIDEBAR_TYPE, EnrichedSidebarData, SidebarData } from './types';

export const isSidebarVisible = (state: SidebarStatePart, type: string): boolean =>
    !!state.sidebar.sidebar && state.sidebar.sidebar.type === type;

export const sidebarData = (state: SidebarStatePart, key: string): SidebarData | undefined => {
    if (state.sidebar.sidebar?.type === key) {
        return state.sidebar.sidebar.data;
    }
    return undefined;
};

const getDriverSidebarRaw = (state: SidebarStatePart) => state.sidebar.sidebar;

export const driverSidebarData = createSelector(
    [getDriverSidebarRaw],
    (sidebar): EnrichedSidebarData | undefined => {
        if (!sidebar || sidebar.type !== DRIVER_SIDEBAR_TYPE) {
            return undefined;
        }

        const data = sidebar.data as BaseSidebarData;
        if (!data) {
            return undefined;
        }

        const vehicles = data.vehicles ?? [];
        const drivers = data.drivers ?? [];
        const { electric: electricVehicles, fuel: fuelVehicles } = separateVehiclesByType(vehicles);

        return {
            ...data,
            childrenIds: data.childrenIds ?? [],
            driverIds: drivers.map((d) => d.id),
            electricVehicles,
            electricVehicleIds: electricVehicles.map((v) => v.id),
            fuelVehicles,
            fuelVehicleIds: fuelVehicles.map((v) => v.id),
            containsElectricVehicle: electricVehicles.length > 0,
            containsCombustionVehicle: fuelVehicles.length > 0,
            isVehiclesNameClickable: (data.children?.length ?? 0) > 1,
        };
    },
);
